module.exports = __webpack_public_path__ + "img/aeroland-payment-box-icon-01.cf0ef093.png";